module.exports = __webpack_public_path__ + "img/order-activity-mailbox.4d739585.svg";